export default "__VITE_ASSET__I33LmGBg__"